export default __webpack_public_path__ + "static/media/Ancient Warhammer.f1b16073.jpg";